import { constants } from './constants'

const resetStore = () => ({
  type: constants.STORE_RESET,
})

export const actions = {
  resetStore,
}
